import styles from "./HomePageButton.module.css";

import { NavLink } from "react-router-dom";

import newChecklist from "../../../assets/new_checklist.png";
import checklistMonitor from "../../../assets/checklist_monitor.png";
import reporting from "../../../assets/reporting.png";
import override from "../../../assets/override.png";

const HomePageButton = (props) => {
  let icon;
  let iconStyle = "";
  let buttonStyle = `${styles.buttonStyle} my-2`;

  switch (props.children) {
    case "New Checklist":
      icon = newChecklist;
      break;
    case "Checklist Monitor":
      icon = checklistMonitor;
      break;
    case "Reporting":
      icon = reporting;
      break;
    case "Override":
      icon = override;
      break;
    default:
      iconStyle = "d-none";
      icon = "";
      // buttonStyle = `${styles.navLink} ${props.class} my-2 ${styles.colorRed}`;
  }

  let button;

  if (!props.disabled) {
    props.toLink ? button = (
      <div className={`${buttonStyle}`}>
        {props.children === "Checklist Monitor" && props.checklistsIndicator && <span className={styles.checklistsIndicator}>{props.numberOfChecklists}</span>}
        <NavLink
          to={props.toLink}
          className={styles.navLink}
        >
          {props.children}
        </NavLink>
      </div>
    ) : (
      button = <div className={`${buttonStyle}`}>
      {props.children === "Checklist Monitor" && props.checklistsIndicator && <span className={styles.checklistsIndicator}>{props.numberOfChecklists}</span>}
      <a
        href={props.externalLink}
        rel="noreferrer noopener"
        target="_blank"
        className={styles.navLink}
      >
        {props.children}
      </a>
    </div>
    )
  } else {
    button = (
      <button
        disabled
        className={`${buttonStyle} text-center`}
      >{props.children}</button>
    );
  }

  return (
    <div className="d-flex justify-content-around">
      <img src={icon} className={` ${styles.icon} ${iconStyle}`} alt="icon" />
      {button}
      {icon && <div
        className={`${styles.helperDiv} ${
          props.children === "New Operational Area" ? "d-none" : ""
        }`}
      ></div>}
    </div>
  );
};

export default HomePageButton;
